/** Short messages at the top of the screen. A small store of its own; at most three at a time. */
import { createStore } from '@core/store';

export interface Toast {
  id: number;
  text: string;
  big: boolean;
  out: boolean;
}

export const toasts = createStore<{ items: readonly Toast[] }>({ items: [] });
let nextId = 1;

export function showToast(text: string, big = false): void {
  const id = nextId++;
  const items = [...toasts.get().items, { id, text, big, out: false }].slice(-3);
  toasts.set({ items });
  setTimeout(
    () => {
      toasts.set({
        items: toasts.get().items.map((item) => (item.id === id ? { ...item, out: true } : item)),
      });
      setTimeout(
        () => toasts.set({ items: toasts.get().items.filter((item) => item.id !== id) }),
        320,
      );
    },
    big ? 5200 : 3600,
  );
}
